import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/globals.css'

async function enableMocking() {
  if (!import.meta.env.DEV && !import.meta.env.VITE_ENABLE_MOCKS && !window._env_?.VITE_ENABLE_MOCKS) return

  const { worker } = await import('./test/mocks/browser')
  return worker.start({
    onUnhandledRequest: 'bypass',
  })
}

enableMocking().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
})
